module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAGRJREFUWEdjZBhgwDjA9jOMOmA0BEZDgGAIXLly5T9SVn2no6MjjCvrXrt2zeLfv3/HYfKMjIxbtbW1ffBl9VEHjIbAaAiMhsBoCIyGwGgIDP4QoHWznWAIjDpgNARGQ4DWIQAA0mTQIdBfDS0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/pause3.png
// module id = NB2h
// module chunks = 1